<template>
  <div class="modal">
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <div style="width: 500px" class="modal-content">
      <div class="payment">
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="cancel"
        >
          <v-icon @click="$emit('cancel')" dark style="font-size: 20px"
            >fa-times</v-icon
          >
        </v-btn>

        <div class="modal-title">
          <h1 class="point-title">Completar información</h1>
        </div>

        <div class="errands-container">
          <div v-for="(item, id) of allPoints" :key="id">
            <p style="color: #FF1744" class="mt-5 mb-0 pb-0 point-name">
              <span>{{ id + 1 }}</span
              >. {{ item.address.join(",") }}
            </p>
            <v-text-field
              :class="{ errorC: validation && !item.contactName }"
              label="Nombre de contacto"
              class="mt-5"
              v-model="item.contactName"
              hide-details
              rounded
              filled
            />
            <v-text-field
              type="number"
              hide-details
              rounded
              filled
              class="mt-5"
              @keypress="isNumber"
              :class="{ errorC: validation && !item.contactPhone }"
              label="Teléfono de contacto"
              v-model.number="item.contactPhone"
            />
            <v-textarea
              rounded
              filled
              rows="2"
              hide-details
              class="mt-5"
              placeholder="Comentarios"
              v-model="item.comments"
            />
            <!-- <hr> -->
          </div>
        </div>

        <!-- <v-text-field
          rounded
          filled
          placeholder="Hora de incio"
          label="Hora de incio"
          class="mt-2 mr-3 mb-2"
          v-model="deliveryTime"
          @click="showTimePicker"
          hide-details
        /> -->
        <div class="modal-btn">
          <v-btn
            color="primary"
            @click="validateFields"
            height="65%"
            block
            rounded
            filled
            >Continuar</v-btn
          >
        </div>
      </div>
    </div>

    <!-- <v-dialog
      width="500"
      style="z-index: 345"
      persistent
      v-model="timePickerDialog"
      v-if="timePickerDialog"
    >
      <time-picker
        @success="timeSelected"
        :timeData="timeData"
        @cancel="timePickerDialog = false"
      ></time-picker>
    </v-dialog> -->
  </div>
</template>

<script>
// import timePicker from "@/components/timePicker";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  name: "confirm",
  props: ["routeData", "waypoints"],
  components: {
    // timePicker,
  },
  data() {
    return {
      validation: false,
      snackbarText: "",
      snackbar: false,
      show: true,
      // timePickerDialog: false,
      // timeData: {
      //   soon: true,
      // },
    };
  },
  computed: {
    allPoints() {
      let points = [];

      for (let i = 0; i < this.waypoints.length; i++) {
        if (this.routeData[`point_${i + 1}`]) {
          points.push(this.routeData[`point_${i + 1}`]);
        }
      }

      return points;
    },
    // deliveryTime() {
    //   if (this.timeData.soon) {
    //     return "Lo antes posible";
    //   } else {
    //     return moment(
    //       `${this.timeData.date} ${this.timeData.time}`,
    //       "YYYY-MM-DD hh:mm"
    //     ).format("DD-MMM-YY hh:mm A");
    //   }
    // },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    timeSelected(e) {
      this.timePickerDialog = false;
      this.timeData = e;
    },
    showTimePicker() {
      this.timePickerDialog = true;
    },
    validateFields() {
      return new Promise((resolve, reject) => {
        let hasErrors = false;

        for (let i = 1; i <= this.waypoints.length; i++) {
          const point = this.routeData[`point_${i}`];
          if (point) {
            if (!point.contactPhone || !point.contactName) {
              this.snackbarText =
                "Debe completar los nombres de contacto y números de teléfono en cada punto.";
              this.snackbar = true;
              this.validation = true;
              hasErrors = true;
              return resolve(false);
            }
          }
        }

        if (!hasErrors) {
          for (let i = 0; i < this.allPoints.length; i++) {
            const point = this.allPoints[i];
            this.routeData[`point_${i + 1}`].contactName = point.contactName;
            this.routeData[`point_${i + 1}`].contactPhone = point.contactPhone;
            this.routeData[`point_${i + 1}`].comments = point.comments;
          }

          this.$emit("success", this.routeData);
        }
      });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>


<style lang="scss">
.errands-container {
  color: #000000ad;
  padding: 10px;
}
.close {
  width: 20px;
}
.coor {
  color: #FF1744;
}

.text {
  border-radius: 10px;
  border: 0;
  width: 95%;
  padding: 10px;
  margin: 20px 0 20px 0;
  min-height: 30px;
}
textarea {
  resize: none;
}

.point-title {
  max-width: 95%;
  text-align: start;
}

.errorC {
  border: 1px solid red;
}

.point-name {
  max-width: 100%;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>